import type { Variants } from "motion/react";

// ── Reusable primitives ──────────────────────────────────────────────

export const fadeInVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6 },
  },
};

export const slideUpVariants: Variants = {
  hidden: { y: 30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export const slideFromLeftVariants: Variants = {
  hidden: { x: -40, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export const slideFromRightVariants: Variants = {
  hidden: { x: 40, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// ── Stagger containers ───────────────────────────────────────────────

/** Default stagger container (0.2s between children) */
export const staggerContainerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

/**
 * Factory for stagger containers with custom timing.
 *
 * @param stagger  - seconds between each child animation
 * @param delay    - seconds before the first child starts
 *
 * @example
 * ```tsx
 * <motion.div variants={createStaggerContainer(0.3, 0.2)}>
 * ```
 */
export function createStaggerContainer(
  stagger: number,
  delay?: number,
): Variants {
  return {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: stagger,
        ...(delay != null && { delayChildren: delay }),
      },
    },
  };
}
